import TransmedProcessSlide from "./slide";

function TransmedProcessRevoked({ message }: { message: string | null }) {
  return (
    <TransmedProcessSlide>
      <h3>
        {message === null
          ? "Ai renunțat la loc"
          : "Participarea ta a fost revocată"}
      </h3>
      <span style={{ marginTop: "var(--gap-big)" }}>
        {message ??
          "Ne pare rău! Te așteptăm, totuși, să participi la următoarele ediții Transmed."}
      </span>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessRevoked;
